<template>
    <div class="empty-container">
        <Icon type="zanwushuju" class="empty-icon" />
        <p>暂无数据</p>
    </div>
</template>

<script>
import Icon from '../Icon/index.vue'
export default {
    components: {
        Icon
    }
}
</script>

<style lang="less" scoped>
.empty-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: gray;
    text-align: center;
}

.iconfont{
    font-size: 20px;
}
</style>